import { ApiRoutes } from '@gr/core/api-routes';
import type { ParamValue } from '@gr/core/platform/config/registry';
import type { PersonalSettingDto, PersonalSettingsDto } from '@gr/core/platform/user-preferences/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class PreferencesApi {
  constructor(private readonly http: HttpClient) {}

  // PREF-UC-3
  personalSettings(): Promise<OperationResult<PersonalSettingsDto>> {
    return this.http.get(ApiRoutes.preferences.settings);
  }
  savePersonalSetting(key: string, value: ParamValue): Promise<OperationResult<PersonalSettingDto>> {
    return this.http.put(ApiRoutes.preferences.setting(key), { value });
  }
  resetPersonalSetting(key: string): Promise<OperationResult<PersonalSettingDto>> {
    return this.http.delete(ApiRoutes.preferences.setting(key));
  }
}
